import { Pipe, PipeTransform } from '@angular/core';
import { titleize } from 'inflection';
import * as _ from 'lodash';

@Pipe({
    name: 'titleize',
    standalone: false
})
export class TitleizePipe implements PipeTransform {
  transform(value: string): any {
    return titleize(_.lowerCase(value));
  }
}
